import { NotificationEventItem } from 'shared'
import { useCIMSNotificationsContext } from '../CIMSNotificationsContext'
import { PropsWithChildren } from 'react'
import { Space } from 'antd'
import { useCIMSNotificationsPanelContext } from './CIMSNotificationsPanelContext'
import CIMSDivider from '../../CIMSDivider'

export function PrefixContent<Event extends NotificationEventItem>({
  children,
}: PropsWithChildren<object>) {
  const { event } = useCIMSNotificationsPanelContext<Event>()
  const { prefix, __debug } = useCIMSNotificationsContext<Event, any>()
  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {__debug && <CIMSDivider>DEBUG : PREFIX CONTENT</CIMSDivider>}
      {prefix && typeof prefix === 'function' ? prefix(event) : prefix}
      {children}
    </Space>
  )
}

export default PrefixContent
